export function formatTimeAgo(timestamp) {
  if (!timestamp?.seconds) return "Just now";

  const created = new Date(timestamp.seconds * 1000);
  const now = new Date();

  const diffMs = now - created;

  const minutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(diffMs / 3600000);
  const days = Math.floor(diffMs / 86400000);

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;

  return `${days}d ago`;
}